import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import defaultState from './defaultState';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state: defaultState
};



// WEBPACK FOOTER //
// ./src/store/modules/mfa/index.js